import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'operation-manager-section';
const BLOCK_ID = 'operation-manager-section';
const PLACEHOLDER_LABEL = 'Operationsverwaltung';

export default function operationManager(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-operation-manager') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Operationsverwaltung',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-operation-manager',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [{}],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Operationsverwaltung',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14Zm-2-10H7v2h10V9Zm0 4H7v2h10v-2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-operation-manager',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
